import { render, staticRenderFns } from "./QZdetail.vue?vue&type=template&id=543c6842&scoped=true"
import script from "./QZdetail.vue?vue&type=script&lang=js"
export * from "./QZdetail.vue?vue&type=script&lang=js"
import style0 from "./QZdetail.vue?vue&type=style&index=0&id=543c6842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c6842",
  null
  
)

export default component.exports